'use server'

import axios from 'axios'

const getPublicClient = () => {
    const baseURL = import.meta.env.VITE_API_BASE_URL

    return axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 30000,
    })
}

export interface PublicConsentData {
    id: number
    type: string
    typeLabel: string
    content: string
    alreadySigned: boolean
    patientSignedAt: string | null
    revokedAt: string | null
    client: { name: string }
    professional: { name: string }
    company: { name: string; tradingName: string | null }
}

export interface PublicApiResponse<T> {
    success: boolean
    result: T
    error?: string
}

export async function getPublicConsent(
    token: string
): Promise<PublicApiResponse<PublicConsentData>> {
    try {
        const client = getPublicClient()
        const response = await client.get(`/consents/public/${token}`)
        return { success: true, result: response.data }
    } catch (error: any) {
        return {
            success: false,
            result: {} as any,
            error:
                error?.response?.data?.message ||
                'Erro ao carregar dados do consentimento',
        }
    }
}

export async function signPublicConsent(
    token: string,
    signatureData: string
): Promise<PublicApiResponse<{ message: string }>> {
    try {
        const client = getPublicClient()
        const response = await client.post(`/consents/public/${token}/sign`, {
            signatureData,
        })
        return { success: true, result: response.data }
    } catch (error: any) {
        return {
            success: false,
            result: {} as any,
            error:
                error?.response?.data?.message ||
                'Erro ao registrar assinatura',
        }
    }
}
